export default "__VITE_ASSET__FA67itvw__"